export const createLoadingIndicatorSlice = (set) => ({
  loading: false,
  setLoading: (loading) => {
    set((state) => {
      state.loadingIndicator.loading = loading;
    });
  },
});
